<template>
  <button
    title="Add to Playlist"
    v-tippy="{ placement: 'top' }"
    @click="showModal"
  >
    <font-awesome-icon :icon="faStream" />
  </button>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faStream } from "@fortawesome/pro-light-svg-icons/faStream";
import AddToPlaylistModal from "./add-to-playlist-modal";
import { create } from "vue-modal-dialogs";

const showModal = create({
  component: AddToPlaylistModal,
  wrapper: "activity-summary",
});

export default {
  components: {
    FontAwesomeIcon,
  },
  data() {
    return {
      faStream,
    };
  },
  methods: {
    showModal() {
      showModal();
    },
  },
};
</script>



// WEBPACK FOOTER //
// add-to-playlist-button.vue?5fdb5d00